"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.arrayMethodsBuilders = exports.replaceArray = exports.methodNames = void 0;
var addObjectToDataset_1 = require("./addObjectToDataset");
exports.methodNames = new Set([
    "copyWithin",
    "fill",
    "pop",
    "push",
    "reverse",
    "shift",
    "sort",
    "splice",
    "unshift",
]);
function replaceArray(target, replacement, dataset, contextUtil) {
    var _a;
    if (target[0][0] && target[0][1]) {
        var itemToAdd = (_a = {
                "@id": target[0][0]
            },
            _a[contextUtil.iriToKey(target[0][1].value)] = replacement,
            _a);
        (0, addObjectToDataset_1.addObjectToDataset)(itemToAdd, dataset, contextUtil, new Set(), true);
    }
}
exports.replaceArray = replaceArray;
exports.arrayMethodsBuilders = {
    copyWithin: function (target, dataset, contextUtil) {
        return function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var toReturn = (_a = target[1]).copyWithin.apply(_a, __spreadArray([], __read(args), false));
            replaceArray(target, target[1], dataset, contextUtil);
            return toReturn;
        };
    },
    fill: function (target, dataset, contextUtil) {
        return function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var toReturn = (_a = target[1]).fill.apply(_a, __spreadArray([], __read(args), false));
            replaceArray(target, target[1], dataset, contextUtil);
            return toReturn;
        };
    },
    pop: function (target, dataset, contextUtil) {
        return function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var toReturn = (_a = target[1]).pop.apply(_a, __spreadArray([], __read(args), false));
            replaceArray(target, target[1], dataset, contextUtil);
            return toReturn;
        };
    },
    // TODO: Push is an O(n) operation. It could be made O(1), but I
    // was lazy. I'll come back to fix this.
    push: function (target, dataset, contextUtil) {
        return function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var toReturn = (_a = target[1]).push.apply(_a, __spreadArray([], __read(args), false));
            replaceArray(target, target[1], dataset, contextUtil);
            return toReturn;
        };
    },
    reverse: function (target) {
        return function () {
            return target[1].reverse();
        };
    },
    shift: function (target, dataset, contextUtil) {
        return function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var toReturn = (_a = target[1]).shift.apply(_a, __spreadArray([], __read(args), false));
            replaceArray(target, target[1], dataset, contextUtil);
            return toReturn;
        };
    },
    sort: function (target) {
        return function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return (_a = target[1]).sort.apply(_a, __spreadArray([], __read(args), false));
        };
    },
    splice: function (target, dataset, contextUtil) {
        return function (start, deleteCount) {
            var _a;
            var items = [];
            for (var _i = 2; _i < arguments.length; _i++) {
                items[_i - 2] = arguments[_i];
            }
            var toReturn = items.length > 0
                ? (_a = target[1]).splice.apply(_a, __spreadArray([start, deleteCount], __read(items), false)) : target[1].splice(start, deleteCount);
            replaceArray(target, target[1], dataset, contextUtil);
            return toReturn;
        };
    },
    unshift: function (target, dataset, contextUtil) {
        return function () {
            var _a;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var toReturn = (_a = target[1]).unshift.apply(_a, __spreadArray([], __read(args), false));
            replaceArray(target, target[1], dataset, contextUtil);
            return toReturn;
        };
    },
};
